export const FETCH_SITE_LIST_REQUEST = 'FETCH_SITE_LIST_REQUEST';
export const FETCH_SITE_LIST_SUCCESS = 'FETCH_SITE_LIST_SUCCESS';
export const FETCH_SITE_LIST_FAILURE = 'FETCH_SITE_LIST_FAILURE';

export const SET_SITE_DETAIL = 'SET_SITE_DETAIL';
export const CLEAR_SITE_DETAIL = 'CLEAR_SITE_DETAIL';

export const FETCH_NUDGE_STATUS_REQUEST = 'FETCH_NUDGE_STATUS_REQUEST';
export const FETCH_NUDGE_STATUS_SUCCESS = 'FETCH_NUDGE_STATUS_SUCCESS';
export const FETCH_NUDGE_STATUS_FAILURE = 'FETCH_NUDGE_STATUS_FAILURE';

export const CLOSE_NUDGE = 'CLOSE_NUDGE';
